import { Action } from 'redux'

import { ServiceStatus as ServiceStatusInterface } from '../../interfaces/client/ServiceStatus'

export const SET_SERVICE_STATUS = 'SET_SERVICE_STATUS'

export interface SetStatusAction extends Action {
  type: 'SET_SERVICE_STATUS',
  data:  ServiceStatusInterface
}

export default (data: ServiceStatusInterface): SetStatusAction => ({
  type: SET_SERVICE_STATUS,
  data,
})
